import { useCallback } from 'react';
import { useQuery } from 'react-apollo';
import { useDispatch, useSelector } from 'react-redux';

import {
  notificationsSidebarToggle,
  setNotificationsSidebarState,
} from '../../../redux/layout/layoutActions';
import { accountActionableItems } from '../../../../../graphql/queries/account';

const useActionableItemMenu = () => {
  const { data: { me: user } = {} } = useQuery(accountActionableItems);

  const dispatch = useDispatch();

  const onNotificationsSidebarToggle = useCallback(
    () => dispatch(notificationsSidebarToggle()),
    [],
  );
  const onNotificationsSidebarCollapse = useCallback(
    () => dispatch(setNotificationsSidebarState(false)),
    [],
  );
  const { notificationsSidebarExpanded } = useSelector(
    state => state.pro.layout,
  );

  return {
    onNotificationsSidebarCollapse,
    onNotificationsSidebarToggle,
    notificationsSidebarExpanded,
    actionableItems: user?.actionable_items,
  };
};

export default useActionableItemMenu;
